export const emailVerificationURL = () =>
    window.location.origin.concat('/verify');

export const recoverPasswordURL = () =>
    window.location.origin.concat('/recover-password');

export const redirectToHttps = () => {
    if (location.protocol !== 'https:') {
        location.href =
            'https:' +
            window.location.href.substring(window.location.protocol.length);
    }
};

export const getDomainName = () => {
    let domain = window.location.origin;
    domain = domain.replace('http://', '');
    domain = domain.replace('https://', '');
    return domain;
};

export const getMainDomainUrl = () => {
    let domain = window.location.hostname;

    // Remove subdomain if exists
    const firstDotIndex = domain.indexOf('.');
    if (firstDotIndex !== -1) {
        const secondDotIndex = domain.indexOf('.');
        // if secondDotIndex is not -1, the domain then contains a subdomain
        if (secondDotIndex !== -1) {
            domain = domain.substring(firstDotIndex);
        }
    }

    return domain;
};

export const getSubDomain = () => {
    let domain = window.location.hostname;
    const indexOfDot = domain.indexOf('.');
    return indexOfDot !== -1 ? domain.substring(0, indexOfDot) : null;
};

export const objectToQueryString = queryObject => {
    return '?'.concat(
        Object.keys(queryObject)
            .map(key => key.concat('=', queryObject[key], '&'))
            .join()
    );
};
